// eslint-disable-next-line import/prefer-default-export
export const getFloatsState = (state) => state.floats;
